import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { RootState } from 'src/_common/models/redux/store';
import TrackClass from 'core/logger/track';

import { useLatestRef } from '@Common/hooks';
import { Loadable } from '../common/Loadable';

export type PrivateRouteGuardOwnProps = {
  renderLoader: React.FC<any>;
  beforeRedirect?: Function;
};

export type PrivateRouteGuardProps = React.PropsWithChildren<PrivateRouteGuardOwnProps>;

export function PrivateRouteGuard(props: PrivateRouteGuardProps) {
  const router = useRouter();
  const isSyncWithDB = useSelector((state: RootState) => state.user.syncedWithDb || false);
  const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated || false);
  const beforeRedirectRef = useLatestRef<Function | undefined>(props.beforeRedirect);
  // render child must be rendered if and only if the user is logged in
  // else redirect to login page
  useEffect(() => {
    if (isSyncWithDB && !isAuthenticated) {
      TrackClass.getInstance().visitedPage(router.pathname, '');
      beforeRedirectRef.current?.();
      router
        .push({
          pathname: '/login',
          query: {
            referrer: 'cowriter',
            returnUrl: '/co-writer',
          },
        })
        .then(() => {
          router.reload();
        });
    }
  }, [isSyncWithDB, isAuthenticated]);

  const isLoadingComplete = isSyncWithDB && isAuthenticated;
  return (
    <Loadable loader={<props.renderLoader />} loading={!isLoadingComplete}>
      {props.children}
    </Loadable>
  );
}
